import React from "react";

export default class WuformButton extends React.Component  
{
    render()
    {
        const domain = this.props.env && this.props.env.domain ? this.props.env.domain : '';
        const registerUrl = domain + '/pro/register';

        return (
            <div className="block services successtories mb-5">
                <div className="card">
                    <h3>Get New Customer Leads</h3>
                    <p>If your company provides great service, Hometown can generate new customers for you. Call us at (877) 994-6645 or get started below.</p>
                    <a className="btn btn-primary" href={registerUrl}>Pros Get Started</a>
                </div>
            </div>
        )
    }
};